<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item v-if="form.id" label="用户昵称">
        <a-input :value="form.userNickname" placeholder="-" disabled />
      </a-form-model-item>
      <a-form-model-item v-if="form.id" label="联系方式">
        <a-input :value="form.userContact" placeholder="-" disabled />
      </a-form-model-item>
      <a-form-model-item v-if="form.id" label="订单标题">
        <a-input :value="form.orderTitle" placeholder="-" disabled />
      </a-form-model-item>
      <a-form-model-item label="申述类型" prop="type">
        <a-select
          :key="typeSelectKey"
          v-model="formTypeValue"
          placeholder="请选择申述类型"
          :disabled="!!form.id"
          allow-clear
        >
          <a-select-option v-for="(d, index) in typeOptions" :key="index" :value="getOptionValue(d)">{{ d.label || d.dictLabel }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="申述描述" prop="appealDescription">
        <a-input
          disabled
          v-model="form.appealDescription"
          placeholder="请输入申述描述"
          type="textarea"
          :rows="3"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item label="凭证/说明" prop="proof" v-if="proofImgList.length">
        <div class="proof-images">
          <img
            v-for="(url, i) in proofImgList"
            :key="i"
            v-viewer
            :src="url"
            class="proof-thumb"
          />
        </div>
      </a-form-model-item>
      <a-form-model-item
        v-if="form.id && form.status === 0"
        label="不通过原因"
        prop="result"
      >
        <a-textarea
          v-model="form.result"
          placeholder="不通过原因"
          :rows="4"
          :maxLength="500"
          allow-clear
        />
      </a-form-model-item>
      <a-form-model-item v-if="form.id && form.status === 3 && form.result" label="不通过原因">
        <a-textarea :value="form.result" disabled :rows="3" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button v-if="form.id && form.status === 0" type="primary" :loading="approveLoading" @click="handleApprove">审核通过</a-button>
          <a-button v-if="form.id && form.status === 0" type="primary" danger :loading="rejectLoading" @click="handleReject">审核不通过</a-button>
          <a-button type="dashed" @click="cancel">取消</a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getOrderAppeal, approveOrderAppeal, rejectOrderAppeal } from '@/api/orderAppeal/orderAppeal'

export default {
  name: 'CreateForm',
  dicts: ['order_appeal_type'],
  data() {
    return {
      approveLoading: false,
      rejectLoading: false,
      formTitle: '',
      form: {
        id: null,
        userId: null,
        orderId: null,
        userNickname: null,
        userContact: null,
        orderTitle: null,
        type: undefined,
        appealDescription: null,
        proof: null,
        status: undefined,
        handleType: undefined,
        result: null,
        deductionScore: undefined,
        day: undefined,
        createTime: null,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {
        userId: [{ required: true, message: '用户id不能为空', trigger: 'blur' }],
        orderId: [{ required: true, message: '订单id不能为空', trigger: 'blur' }]
      }
    }
  },
  computed: {
    proofImgList() {
      const p = this.form.proof
      if (!p || typeof p !== 'string') return []
      return p.split(',').map(s => s.trim()).filter(Boolean)
    },
    typeOptions() {
      return this.dict.type['order_appeal_type'] || []
    },
    typeSelectKey() {
      return `${this.form.id || ''}-${this.form.type}-${this.typeOptions.length}`
    },
    formTypeValue: {
      get() {
        const t = this.form.type
        if (t === undefined || t === null || t === '') return undefined
        const num = Number(t)
        return Number.isNaN(num) ? t : num
      },
      set(v) {
        this.form.type = v
      }
    }
  },
  methods: {
    parseDictValue(d) {
      if (d.value !== undefined && d.value !== null) return d.value
      if (d.dictValue !== undefined && d.dictValue !== null) return Number(d.dictValue) || d.dictValue
      return d.value
    },
    getOptionValue(d) {
      const v = d.dictValue !== undefined && d.dictValue !== null ? d.dictValue : d.value
      if (v === undefined || v === null) return undefined
      const num = Number(v)
      return Number.isNaN(num) ? v : num
    },
    onClose() {
      this.open = false
    },
    cancel() {
      this.open = false
      this.reset()
    },
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        orderId: null,
        userNickname: null,
        userContact: null,
        orderTitle: null,
        type: undefined,
        appealDescription: null,
        proof: null,
        status: undefined,
        handleType: undefined,
        result: null,
        deductionScore: undefined,
        day: undefined,
        createTime: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    handleAdd() {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加订单申述'
    },
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getOrderAppeal({ id }).then(response => {
        const data = response.data || response
        this.form = {
          ...data,
          type: data.type !== undefined && data.type !== null ? Number(data.type) : undefined,
          status: data.status !== undefined && data.status !== null ? Number(data.status) : undefined
        }
        this.open = true
        this.formTitle = '订单申述处置'
      })
    },
    handleApprove() {
      if (!this.form.id) return
      this.approveLoading = true
      approveOrderAppeal({ id: this.form.id })
        .then(() => {
          this.$message.success('审核通过，状态已改为待处理', 3)
          this.open = false
          this.$emit('ok')
        })
        .finally(() => {
          this.approveLoading = false
        })
    },
    handleReject() {
      if (!this.form.id) return
      const reason = (this.form.result || '').trim()
      if (!reason) {
        this.$message.warning('请填写审核不通过原因')
        return
      }
      this.rejectLoading = true
      rejectOrderAppeal({ id: this.form.id, result: reason })
        .then(() => {
          this.$message.success('已审核不通过', 3)
          this.open = false
          this.$emit('ok')
        })
        .finally(() => {
          this.rejectLoading = false
        })
    }
  }
}
</script>

<style scoped>
.bottom-control {
  margin-top: 16px;
}
.proof-images {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.proof-thumb {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #e8e8e8;
}
</style>
